<template>
  <v-container
    id="PasswordPromptUpdateBackground"
    fluid
  >
    <v-row class="d-flex column flex-md-row-reverse">
      <v-col
        cols="12"
        md="6"
        class="d-flex justify-center align-center full-height"
      >
        <img
          v-if="tenant.settings.logo === null"
          src="/img/logo.svg"
          alt="Flo Logo in Blue"
          class="logo-size"
        >
        <img
          v-else
          :src="tenant.settings.logo"
          class="logo-size"
        >
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <div class="parallelogram-container">
          <div class="parallelogram d-flex flex-row justify-center">
            <password-prompt-update-component
              :email="email"
              class="d-flex align-center"
            />
          </div>
          <div class="parallelogram2" />
        </div>
      </v-col>
    </v-row>
    <p class="bottom-right">
      <a
        href="https://flo.co.uk"
        title="Recruitment Software by Flo"
        target="_blank"
      >Recruitment Software by Flo</a>
    </p>
  </v-container>
</template>
<script>
import PasswordPromptUpdateComponent from './PasswordPromptUpdateComponent.vue'
export default {
  name: 'PasswordPromptUpdateBackgroundComponent',
  components: { PasswordPromptUpdateComponent },
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {}
      }
    },
    email: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang="scss">
@import './resources/sass/variables';
#PasswordPromptUpdateBackground {
  .bottom-right {
    color: grey;
    position: fixed;
    bottom : 0;
    right: 1rem;
  }
  .bottom-right a {
    text-decoration: none;
    color: grey;
  }
  .pab {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .logo-size{
    width: auto;
  }
  .register-comp{
    max-width: 95vw;
    max-height: 95vh;
  }
  @media screen and (max-width: 960px){
    .bottom-right {
      display: none;
    }
  }
  @media screen and (min-width: 960px){
    .full-height{
      height: 100vh;
    }
    .logo-size{
      width: auto;
    }
  }
  .parallelogram {
    position: fixed;
    bottom: -10%;
    left: 0;
    width: 100vw;
    height: 70vh;
    min-height: 600px;
    background-color: $agencyColorPrimary;
    transform: skewY(10deg);
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    @media screen and (min-width: 960px) {
      bottom: 0;
      width: 600px;
      height: 100vh;
      transform: skewX(-15deg);
    }
    @media screen and (min-width: 1200px) {
      width: 50vw;
    }
  }
  .parallelogram2 {
    position: fixed;
    bottom: -80%;
    left: 0;
    width: 100vw;
    height: 80vh;
    background-color: $agencyColorSecondary;
    transform: skewY(10deg);
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    @media screen and (min-width: 960px) {
      bottom: 0;
      left: -50%;
      width: 600px;
      height: 100vh;
      transform: skewX(-15deg);
    }
    @media screen and (min-width: 1200px) {
      left: -50%;
      width: 52vw;
    }
  }
}
</style>
